import { ApiBase } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
export class KaiyakuApi extends ApiBase {
    findForInput() {
        return this.api.get(`kaiyaku/forInput/${myPageStore.selectedNyukyokeiyakuNo}`);
    }
    findHasonInfo() {
        return this.api.get(`kaiyaku/hason/${myPageStore.selectedNyukyokeiyakuNo}`);
    }
    update(command) {
        return this.request(command);
    }
    updateForComplete(command) {
        return this.request(command);
    }
    loadTaikyoButtonText() {
        return this.api.get("message/taikyo/button");
    }
    loadHasonText() {
        return this.api.get(`message/kaiyaku/hason/${myPageStore.selectedNyukyokeiyakuNo}`);
    }
    loadTsuchiGuideText() {
        return this.api.get(`message/kaiyaku/guide/${myPageStore.selectedNyukyokeiyakuNo}`);
    }
    loadTsuchiEntryText() {
        return this.api.get(`message/kaiyaku/entry/${myPageStore.selectedNyukyokeiyakuNo}`);
    }
}
